import createCollectionResource from 'src/actions/shared/createResource';
import { IsNotEmpty } from 'class-validator';
import { matchesError } from 'src/models/DomainError';

const MAX_NAME_LENGTH_IN_TOAST = 50;
export class Audience {
  id: string;
  @IsNotEmpty({ message: 'Please enter an Audience name.' })
  name: string;
}

const audiencesResource = createCollectionResource<Audience>({
  name: 'audiences',
  endpoint: 'v1/orgs/:orgId/audiences/:id',
  type: Audience,
  options: {
    getErrorMessage: error => {
      if (matchesError(error, { attr: 'name', code: 'blank' })) {
        return 'Please enter an Audience name';
      }
      if (matchesError(error, { code: 'taken' })) {
        return 'The name already exists. Please use a new one.';
      }
      if (matchesError(error, { attr: 'name', code: 'too_long' })) {
        return 'The name is too long (200 characters max). Please use a shorter one.';
      }
    },
    toastMessages: {
      onAdd: audience => `Created Audience "${audience.name}"`,
      onUpdate: audience => `Updated Audience name to "${audience.name}"`,
      onRemove: () => `Deleted Audience`,
      onAddFail: audience =>
        `Unable to create "${truncateName(audience.name, MAX_NAME_LENGTH_IN_TOAST)}". Please try again.`,
      onUpdateFail: audience =>
        `Unable to change name to "${truncateName(audience.name, MAX_NAME_LENGTH_IN_TOAST)}". Please try again.`,
    },
  },
});

function truncateName(name, maxLength) {
  const isNameTooLong = name.length > maxLength;
  return isNameTooLong ? `${name.substr(0, maxLength)}...` : name;
}

export default audiencesResource;
